import AbstractService from "./AbstractService";
import NexusService from "./NexusService";

export default class ZoneService extends AbstractService {
	static zonesApi = NexusService.zonesApi;

	static getAll() {
		return this.zonesApi.getZones().then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		});
	}

	static create(data) {
		const request = {
			zoneCreatePayload: {},
		};
		if (Object.hasOwn(data, "Name")) {
			request.zoneCreatePayload.Name = data.Name;
		}
		if (Object.hasOwn(data, "OrganizationId")) {
			request.zoneCreatePayload.OrganizationId = data.organizationId;
		}
		return this.zonesApi.createZone(request).then(response => ({ data: response }));
	}

	static update(data) {
		const request = {
			id: data.Id,
			zoneUpdatePayload: {},
		};
		if (Object.hasOwn(data, "Name")) {
			request.zoneUpdatePayload.Name = data.Name;
		}
		if (Object.hasOwn(data, "OrganizationId")) {
			request.zoneUpdatePayload.OrganizationId = data.OrganizationId;
		}
		return this.zonesApi.updateZone(request).then(response => ({ data: response }));
}

	static delete(data) {
		return this.zonesApi.deleteZone({
			id: data.Id,
		});
	}
}
